const router = [
  // 养护计划
  {
    path: "/planReport",
    name: "PlanReport",
    meta: { title: "养护计划" },
    component: () => import("@/views/setting/maintenancePlan/Index.vue"),
  },
  {
    path: "/planReport/add",
    name: "PlanReportAdd",
    meta: {
      title: "新增养护计划",
      activeMenu: "/planReport",
    },
    component: () => import("@/views/setting/maintenancePlan/Add.vue"),
  },
  {
    path: "/planReport/add:planId",
    name: "PlanReportEdit",
    meta: { title: "修改养护计划", activeMenu: "/planReport" },
    component: () => import("@/views/setting/maintenancePlan/Add.vue"),
  },
  {
    path: "/planReport/detail:planId",
    name: "PlanReportDetail",
    meta: { title: "查看养护计划", activeMenu: "/planReport" },
    component: () => import("@/views/setting/maintenancePlan/Detail.vue"),
  },
  // 品质巡查
  {
    path: "/patrol/patrolTask",
    name: "patrolTaskList",
    meta: {
      title: "巡查任务",
      hasBack: false,
    },
    component: () => import("@/views/setting/patrol/task/List.vue"),
  },
  // {
  //   path: '/patrol/patrolIssue',
  //   meta: {
  //     title: '巡查问题',
  //     hasBack: false
  //   },
  //   component: () => import('@/views/setting/patrol/issue/List.vue')
  // },
  {
    path: "/patrol/processinspection",
    name: "processinspection",
    component: () => import("@/views/setting/process/ProcessInspection.vue"),
    meta: {
      title: "问题工单",
      hasBack: false,
    },
  },
  {
    path: "/patrol/patrolPoint",
    name: "patrolPointList",
    meta: {
      title: "巡查点位",
      hasBack: false,
    },
    component: () => import("@/views/setting/patrol/point/List.vue"),
  },
  {
    path: "/patrol/patrolElement",
    name: "patrolElementList",
    meta: {
      title: "巡查要素",
      hasBack: false,
    },
    component: () => import("@/views/setting/patrol/element/List.vue"),
  },
  {
    path: "/patrol/patrolExport",
    meta: {
      title: "我的导出",
      hasBack: false,
    },
    component: () => import("@/views/setting/patrol/export/Index.vue"),
  },
  {
    path: "/patrol/patrolTask/add",
    name: "patrolTaskAdd",
    meta: {
      title: "新增巡查任务",
    },
    component: () => import("@/views/setting/patrol/task/Add.vue"),
  },
  {
    path: "/patrol/patrolTask/planDetail:id",
    name: "patrolTaskPlanDetail",
    meta: {
      title: "执行记录",
    },
    component: () => import("@/views/setting/patrol/task/Detail.vue"),
  },
  {
    path: "/patrol/patrolTask/planDetail:id/detail:taskId",
    name: "patrolTaskDetail",
    meta: {
      title: "详情",
    },
    component: () => import("@/views/setting/patrol/task/TaskDetail.vue"),
  },
  {
    path: "/patrol/patrolIssue/detail:issueId",
    name: "patrolIssueDetail",
    meta: {
      title: "详情",
    },
    component: () => import("@/views/setting/patrol/issue/Detail.vue"),
  },
  {
    path: "/patrol/patrolPoint/add",
    name: "patrolPointAdd",
    meta: {
      title: "新增点位",
    },
    component: () => import("@/views/setting/patrol/point/Add.vue"),
  },
  {
    path: "/patrol/patrolPoint/edit:id",
    name: "patrolPointEdit",
    meta: {
      title: "编辑点位",
    },
    component: () => import("@/views/setting/patrol/point/Add.vue"),
  },
  {
    path: "/patrol/patrolPoint/detail:id",
    name: "patrolPointDetail",
    meta: {
      title: "巡查点位详情",
    },
    component: () => import("@/views/setting/patrol/point/Detail.vue"),
  },
  {
    path: "/patrol/patrolElement/add",
    name: "patrolElementAdd",
    meta: {
      title: "新增要素",
    },
    component: () => import("@/views/setting/patrol/element/Add.vue"),
  },
  {
    path: "/patrol/patrolElement/edit:elementId",
    name: "patrolElementEdit",
    meta: {
      title: "编辑要素",
    },
    component: () => import("@/views/setting/patrol/element/Add.vue"),
  },
  {
    path: "/patrol/patrolElement/detail:elementId",
    name: "patrolElementDetail",
    meta: {
      title: "巡查要素详情",
    },
    component: () => import("@/views/setting/patrol/element/Detail.vue"),
  },
  // 养护日报
  {
    path: "/maintenanceDaily",
    name: "maintenanceDaily",
    component: () => import("@/views/setting/maintenanceDay/Index.vue"),
    meta: {
      title: "养护日报",
    },
  },
  {
    path: "/maintenanceDaily/add",
    name: "maintenanceDailyAdd",
    meta: {
      title: "新增养护日报",
      activeMenu: "/maintenanceDaily",
    },
    component: () =>
      import("@/views/setting/maintenanceDay/AddMaintenanceDay.vue"),
  },
  {
    path: "/maintenanceDaily/edit",
    name: "maintenanceDailyEdit",
    meta: {
      title: "编辑养护日报",
      activeMenu: "/maintenanceDaily",
    },
    component: () =>
      import("@/views/setting/maintenanceDay/AddMaintenanceDay.vue"),
  },
  {
    path: "/maintenanceDaily/details",
    name: "maintenanceDayDetails",
    meta: {
      title: "日报详情",
      activeMenu: "/maintenanceDaily",
      hasBack: false,
    },
    // component: () => import('@/views/maintenanceDay/maintenanceDayDetails.vue')
    component: () =>
      import("@/views/setting/maintenanceDay/maintenanceDayDetails2.vue"),
  },
  {
    path: "/maintenanceDaily/DailyTemplate",
    name: "DailyTemplate",
    component: () =>
      import("@/views/setting/maintenanceDay/DailyTemplateList.vue"),
    meta: {
      title: "日报模板",
      activeMenu: "/maintenanceDaily",
    },
  },
  // 养护工单
  {
    path: "/orderDeploy",
    name: "orderDeploy",
    component: () => import("@/views/setting/workOrder/OrderDeploy.vue"),
    meta: {
      title: "工单配置",
    },
  },
  {
    path: "/myOrder",
    name: "myOrder",
    component: () => import("@/views/setting/workOrder/MyOrder.vue"),
    meta: {
      title: "我的工单",
    },
  },
  {
    path: "/orderManage",
    name: "orderManage",
    component: () => import("@/views/setting/workOrder/OrderManage.vue"),
    meta: {
      title: "工单管理",
    },
  },
  {
    path: "/processworkorder",
    name: "processworkorder",
    component: () => import("@/views/setting/process/ProcessWorkOrder.vue"),
    meta: {
      title: "养护工单",
    },
  },
  {
    path: "/myOrder/add",
    name: "myOrderAdd",
    component: () => import("@/views/setting/workOrder/MyOrderAdd.vue"),
    meta: {
      title: "新增工单",
    },
  },
  // 智能作业
  {
    path: "/irrigation2",
    meta: {
      title: "智慧模型配置",
    },
    component: () => import("@/views/setting/irrigation/IrrigationManage.vue"),
  },
  {
    path: "/irrigation2/SoilHistory:deviceNumber",
    name: "soilHistory",
    meta: {
      title: "历史记录",
    },
    component: () => import("@/views/setting/irrigation/SoilHistory.vue"),
  },
  {
    path: "/irrigation2/detail",
    meta: {
      title: "智慧模型配置",
      activeMenu: "/irrigation2",
    },
    redirect: "/irrigation2/detail/plan",
    component: () => import("@/views/setting/irrigation/IrrigationDetail.vue"),
    children: [
      {
        path: "manage",
        component: () =>
          import("@/views/setting/irrigation/IrrigationArea.vue"),
        meta: {
          title: "喷灌管理",
          activeMenu: "/irrigation2",
        },
      },
      {
        path: "plan",
        component: () =>
          import("@/views/setting/irrigation/IrrigationPlan.vue"),
        meta: {
          title: "设置计划",
          activeMenu: "/irrigation2",
        },
      },
      {
        path: "record",
        component: () =>
          import("@/views/setting/irrigation/IrrigationRecord.vue"),
        meta: {
          title: "喷灌记录",
          activeMenu: "/irrigation2",
        },
      },
    ],
  },
  {
    path: "/irrigation2/addArea",
    name: "irrigationAddArea",
    component: () => import("@/views/setting/irrigation/irrigationAddArea.vue"),
    meta: {
      title: "新增区域",
      hasQuery: true,
      backUrl: "/irrigation/detail/manage",
      activeMenu: "/irrigation2",
    },
  },
  {
    path: "/irrigation2/updateArea:id",
    name: "irrigationUpdateArea",
    component: () => import("@/views/setting/irrigation/irrigationAddArea.vue"),
    meta: {
      title: "编辑区域",
      hasQuery: true,
      backUrl: "/irrigation/detail/manage",
      activeMenu: "/irrigation2",
    },
  },
  // 工人劳务
  {
    path: "/laborManageList/worker",
    name: "worker",
    meta: {
      title: "工人信息",
      hasBack: false,
    },
    component: () =>
      import("@/views/setting/laborManage/projectWorker/List.vue"),
  },
  {
    path: "/laborManageList/onduty",
    name: "projectWorkeronduty",
    meta: {
      title: "在岗情况",
      hasBack: false,
    },
    component: () => import("@/views/setting/laborManage/onduty/List.vue"),
  },
  {
    path: "/laborManageList/teams",
    name: "teams",
    meta: {
      title: "班组信息",
      hasBack: false,
    },
    component: () => import("@/views/setting/laborManage/teams/Index.vue"),
  },
  {
    path: "/laborManageList/worker/playback/:workerId/:projectId",
    name: "workPlay",
    meta: {
      title: "轨迹回放",
      hasBack: true,
    },
    component: () =>
      import("@/views/setting/laborManage/projectWorker/DetailPlayback.vue"),
  },
  {
    path: "/laborManageList/teams/playback/:teamId/:projectId",
    name: "teamsPlay",
    meta: {
      title: "轨迹回放",
      hasBack: true,
    },
    component: () =>
      import("@/views/setting/laborManage/teams/DetailPlayback.vue"),
  },
  {
    path: "/laborManageList/attendance",
    name: "attendance",
    meta: {
      title: "考勤记录",
      hasBack: false,
    },
    component: () => import("@/views/setting/laborManage/attendance/Index.vue"),
  },
  {
    path: "/laborManageList/statistics",
    name: "statistics",
    meta: {
      title: "考勤统计",
      hasBack: false,
    },
    component: () =>
      import("@/views/setting/laborManage/attendance/Statistics.vue"),
  },
  {
    path: "/laborManageList/attendance/teamscorrect",
    name: "correct",
    meta: {
      title: "修正记录",
      hasBack: true,
    },
    component: () =>
      import("@/views/setting/laborManage/attendance/CorrectList.vue"),
  },
  {
    // path: '/projectWorkerList/add',
    path: "/laborManageList/worker/add",
    name: "projectWorkerAdd",
    component: () =>
      import("@/views/setting/laborManage/projectWorker/Add.vue"),
    meta: {
      title: "项目工人添加",
    },
  },
  {
    // path: '/projectWorkerList/edit:workerId',
    path: "/laborManageList/worker/edit:workerId",
    name: "projectWorkerEdit",
    component: () =>
      import("@/views/setting/laborManage/projectWorker/Add.vue"),
    meta: {
      title: "项目工人编辑",
    },
  },
  // 机械劳务
  {
    path: "/laborManageList/taiBanLabor",
    name: "taiBanLabor",
    meta: {
      title: "台班劳务",
      hasBack: false,
    },
    component: () =>
      import("@/views/setting/laborManage/taiBanLabor/Index.vue"),
  },
  {
    path: "/laborManageList/taiBanMachine",
    name: "taiBanMachine",
    meta: {
      title: "台班机械",
      hasBack: false,
    },
    component: () =>
      import("@/views/setting/laborManage/machine/MachineList.vue"),
  },
  {
    path: "/laborManageList/taiBanMachine/add",
    meta: { title: "新增机械", activeMenu: "/laborManageList/taiBanMachine" },
    component: () =>
      import("@/views/setting/laborManage/machine/MachineAdd.vue"),
  },
  {
    path: "/laborManageList/taiBanMachine/edit",
    meta: { title: "编辑机械", activeMenu: "/laborManageList/taiBanMachine" },
    component: () =>
      import("@/views/setting/laborManage/machine/MachineAdd.vue"),
  },
  {
    path: "/laborManageList/taiBanMachine/detail",
    meta: { title: "机械详情", activeMenu: "/laborManageList/taiBanMachine" },
    component: () =>
      import("@/views/setting/laborManage/machine/MachineDetail.vue"),
  },
  {
    path: "/laborManageList/taiBanMachine/add",
    meta: { title: "新增台班" },
    component: () => import("@/views/setting/laborManage/taiBanLabor/Add.vue"),
  },
  {
    path: "/laborManageList/taiBanMachine/edit",
    meta: { title: "编辑台班" },
    component: () => import("@/views/setting/laborManage/taiBanLabor/Add.vue"),
  },
  {
    path: "/laborManageList/taiBanMachine/detail",
    meta: { title: "台班详情" },
    component: () =>
      import("@/views/setting/laborManage/taiBanLabor/Details.vue"),
  },

  // 组织架构
  {
    path: "/department",
    name: "department",
    component: () => import("@/views/setting/department/Department.vue"),
    meta: {
      title: "组织架构",
    },
  },
  {
    path: "/department/add",
    name: "personnelAdd",
    component: () => import("@/views/setting/department/PersonnelAdd.vue"),
    meta: {
      title: "新增人员",
      activeMenu: "/department",
    },
  },
  {
    path: "/department/update:id",
    name: "personnelUpdate",
    component: () => import("@/views/setting/department/PersonnelAdd.vue"),
    meta: {
      title: "编辑人员",
      activeMenu: "/department",
    },
  },
  {
    path: "/department/detail:id",
    name: "personnelDetail",
    component: () => import("@/views/setting/department/PersonnelDetail.vue"),
    meta: {
      title: "人员详情",
      activeMenu: "/department",
    },
  },
  // 角色管理
  {
    path: "/role",
    name: "role",
    component: () => import("@/views/setting/role/Role.vue"),
    meta: {
      title: "角色管理",
    },
  },
  {
    path: "/role/add:orderNum",
    name: "roleAdd",
    component: () => import("@/views/setting/role/RoleAdd.vue"),
    meta: {
      title: "角色新增",
      activeMenu: "/role",
    },
  },
  {
    path: "/role/update:roleId",
    name: "roleUpdate",
    component: () => import("@/views/setting/role/RoleAdd.vue"),
    meta: {
      title: "角色编辑",
      activeMenu: "/role",
    },
  },
  // 操作日志
  {
    path: "/operationLog",
    name: "Log",
    component: () => import("@/views/setting/log/Index.vue"),
    meta: {
      title: "操作日志",
    },
  },
  // 数据字典
  {
    path: "/dictionary",
    name: "dictionary",
    component: () => import("@/views/setting/dictionary/Dictionary.vue"),
    meta: {
      title: "数据字典",
    },
  },
  {
    path: "/suppliermanage",
    name: "suppliermanage",
    meta: {
      title: "供应商管理",
    },
    component: () => import("@/views/setting/suppliermanage/List.vue"),
  },
  {
    path: "/suppliermanage/add",
    name: "addSuppliermanage",
    meta: {
      title: "新增供应商",
      activeMenu: "/suppliermanage",
    },
    component: () => import("@/views/setting/suppliermanage/Add.vue"),
  },
  {
    path: "/suppliermanage/edit:supplierId",
    name: "editSuppliermanage",
    meta: { title: "编辑供应商", activeMenu: "/suppliermanage" },
    component: () => import("@/views/setting/suppliermanage/Add.vue"),
  },
  {
    path: "/suppliermanage/detail",
    name: "detailSuppliermanage",
    meta: { title: "供应商详情", activeMenu: "/suppliermanage" },
    component: () => import("@/views/setting/suppliermanage/Detail.vue"),
  },
  {
    path: "/laborcontract",
    name: "laborcontract",
    meta: {
      title: "劳务包工",
    },
    component: () =>
      import("@/views/setting/laborManage/laborcontract/List.vue"),
  },
  {
    path: "/laborcontract/add",
    name: "laborcontractadd",
    meta: {
      title: "劳务包工新增",
      activeMenu: "/laborcontract",
    },
    component: () =>
      import("@/views/setting/laborManage/laborcontract/Add.vue"),
  },
  {
    path: "/laborcontract/edit",
    name: "laborcontractedit",
    meta: { title: "编辑劳务包工", activeMenu: "/laborcontract" },
    component: () =>
      import("@/views/setting/laborManage/laborcontract/Add.vue"),
  },
  {
    path: "/laborcontract/details",
    name: "laborcontractdetail",
    meta: { title: "劳务包工详情", activeMenu: "/laborcontract" },
    component: () =>
      import("@/views/setting/laborManage/laborcontract/Details.vue"),
  },
];
export default router;
